import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{ borderLess?: boolean }>()(
  (theme, { borderLess }) => ({
    updateRow: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: theme.spacing(3),
    },
    closeIconButton: {
      marginBottom: theme.spacing(2),
    },
    recipientsRowsContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      gap: theme.spacing(4),
      padding: borderLess ? theme.spacing(0) : theme.spacing(4),
      width: '100%',
      boxSizing: 'border-box',
      borderRadius: theme.spacing(0.5),
      border: borderLess ? 'none' : `1px solid ${theme.palette.dividerV2.main}`,
    },
    borderNone: {
      border: 'none !important',
    },
    subTitle: {
      color: theme.palette.labraText.primary,
      fontWeight: 500,
      fontSize: '16px',
      width: '98%',
    },
    recipientTitleWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
    },
    addRecipientBtn: {
      color: theme.palette.select.light,
      cursor: 'pointer',
      fontWeight: 500,
      width: 'fit-content',
      fontSize: '14px !important',
      lineHeight: '20px',
      letterSpacing: 0.1,
    },
    borderRecipient: {
      ...(borderLess
        ? {
            borderBottom: `1px solid ${theme.palette.dividerV2.main}`,
            paddingBottom: theme.spacing(4),
          }
        : {}),
    },
    lastRecipient: {
      border: 'none !important',
      paddingBottom: `${theme.spacing(0)} !important`,
    },
    firstRecipient: {
      paddingTop: `${theme.spacing(0)} !important`,
    },
    removeIconPadding: {
      padding: theme.spacing(0),
    },
  })
)
